import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const NadPlusPage14 = () => {
  const navigate = useNavigate();
  const [storedData, setStoredData] = useState<Record<string, any>>({});
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");
  const [loading, setLoading] = useState<boolean>(true);
  const [appointmentUrl, setAppointmentUrl] = useState<string>("");
  const isStaging = process.env.REACT_APP_ENV === "staging";
  const appointmentTypeId = isStaging
    ? process.env.REACT_APP_NAD_OR_SERMORELIN_STAGING_APPOINTMENT_TYPE_ID
    : process.env.REACT_APP_NAD_OR_SERMORELIN_PROD_APPOINTMENT_TYPE_ID;
  const providerId = isStaging
    ? process.env.REACT_APP_NAD_OR_SERMORELIN_STAGING_PROVIDER_ID
    : process.env.REACT_APP_NAD_OR_SERMORELIN_PROD_PROVIDER_ID;
  const openloopurl = isStaging
    ? process.env.REACT_APP_NAD_OR_SERMORELIN_STAGING_OPENLOOP_URL
    : process.env.REACT_APP_NAD_OR_SERMORELIN_PROD_OPENLOOP_URL;
  const redirectUrlPath = isSermorelinPage
    ? "https://join.claya.com/sermorelin/thank-you"
    : "https://join.claya.com/nadplus/thank-you";

  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
    setStoredData(allValues);

    const firstName = allValues.firstName?.value;
    const lastName = allValues.lastName?.value;
    const email = allValues.email?.value;
    const phoneNumber = allValues.phone?.value;
    const state = allValues.state?.value;

    const url = `${openloopurl}/book-appointment?appointmentTypeId=${appointmentTypeId}&providerId=${providerId}&firstName=${encodeURIComponent(
      firstName
    )}&lastName=${encodeURIComponent(
      lastName
    )}&phoneNumber=${encodeURIComponent(
      phoneNumber
    )}&email=${encodeURIComponent(email)}&state=${encodeURIComponent(
      state
    )}&redirectUrl=${redirectUrlPath}`;
    setAppointmentUrl(url);
  }, []);

  useEffect(() => {
    const step13Completed = localStorage.getItem("completed-step-13");
    const step14Completed = localStorage.getItem("completed-step-14");
    if (isSermorelinPage) {
      if (step14Completed)
        navigate("/sermorelin/getting-started/step-15", { replace: true });
    } else {
      if (step13Completed) {
        navigate("/nadplus/getting-started/step-14", { replace: true });
      }
    }
  }, []);

  return (
    <PageWrapper>
      <div
        className="signup-page-container container"
        style={{ position: "relative" }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "0",
              width: "100vw",
              height: "50vh",
              zIndex: "9999",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={60} sx={{ color: "rgb(137, 67, 149)" }} />
          </div>
        )}
        <iframe
          src={appointmentUrl}
          // title="Book Appointment Widget"
          width="100%"
          height="800px"
          style={{
            border: "none",
          }}
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage14;
